export default __webpack_public_path__ + "static/media/image_notif_permission.5aff2d56.png";